module.exports = __webpack_public_path__ + "static/media/logos_squares_Platinum_CLP.aeea264e.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Platinum_CLP.png
// module id = 89
// module chunks = 0